// @ts-nocheck
"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Script from "next/script";

const HubSpotChatScript = () => {
    const pathname = usePathname();

    useEffect(() => {
        const isRetailPath =
            pathname === "/what-we-do/industries/retail-and-ecommerce/";

        const toggleChatVisibility = () => {
            const chatContainer = document.getElementById(
                "hubspot-messages-iframe-container"
            );
            if (chatContainer) {
                chatContainer.style.display = isRetailPath ? "block" : "none";
                return true;
            }
            return false;
        };

        if (!toggleChatVisibility()) {
            const interval = setInterval(() => {
                if (toggleChatVisibility()) {
                    clearInterval(interval);
                }
            }, 500);
            return () => clearInterval(interval);
        }
    }, [pathname]);

    return (
        <Script
            id="hs-script-loader"
            src="//js-na1.hs-scripts.com/6864149.js"
            strategy="lazyOnload"
        />
    );
};

export default HubSpotChatScript;
